import {
  CloseCircleOutlined,
  PlusCircleFilled,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  Layout,
  message,
  Row,
  Table,
  Tooltip,
} from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useEffect, useState } from "react";
import search from "../../helpers/search";
import useKpiOsa from "../../hooks/useKpiOsa";
import { kpiOsaService } from "../../services/KpiOsaService";
import OsaForm from "../OsaPage/OsaForm";
import { kpi_osa_default } from "./types";
import moment from "moment";
import { structureOSA } from "./osautils";

const { Header, Content } = Layout;

export const getFullDate = (date: string): string => {
  const dateAndTime = date.split("T");
  //return dateAndTime[0];
  //return dateAndTime[0].split("-").reverse().join("-");
  let format_date = moment.utc(date).local();
  return format_date.format("YYYY-MM-DD");
};

const columns = [
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    render: (date: string) => getFullDate(date),
  },
  {
    title: "Manufacturer",
    dataIndex: "manufacturer_name",
    key: "manufacturer_name",
  },
  {
    title: "Country",
    dataIndex: "country_name",
    key: "country_name",
  },
  {
    title: "Category",
    dataIndex: "category_name",
    key: "category_name",
  },
];
const OsaPage: React.FC = function () {
  const [form] = useForm();
  const [searching, setSearching] = useState(false);
  const [visible, setVisible] = useState(false);
  const [osaToDisplay, setOsaToDisplay] = useState([]);
  const [selected, setSelected] = useState(structureOSA(kpi_osa_default));
  const [state, setState] = useState({
    isCreate: false,
    data: [],
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
    pagination_search: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
  });
  const [osa, loadingOsa] = useKpiOsa(state.pagination.current);

  const onSearch = async (key: string) => {
    const { searchWord } = form.getFieldsValue();
    if (!searchWord) {
      message.error("Please enter a valid search string!");
      return;
    }

    setSearching(true);
    // made array to cater more query types in future
    const searchData = [
      {
        key,
        value: encodeURIComponent(searchWord),
        collection: "osa_settings",
      },
    ];

    const searchedData = await search(searchData, kpiOsaService, key);
    setOsaToDisplay(searchedData.data);
    setState({
      ...state,
      pagination_search: {
        ...state.pagination_search,
        total: searchedData.total,
        current: 1,
      },
    });
    setSearching(false);
  };

  const onClose = async () => {
    const { searchWord } = form.getFieldsValue();
    setState({
      ...state,
    });
    setSearching(true);
    if (searchWord) {
      const searchData = [
        {
          key: "manufacturer_name",
          value: encodeURIComponent(searchWord),
          collection: "osa_settings",
        },
      ];

      const searchedData = await search(
        searchData,
        kpiOsaService,
        "manufacturer_name"
      );
      setOsaToDisplay(searchedData.data);
    } else {
      const searchedData = await kpiOsaService.getAll(state.pagination.current);
      const data_osaToDisplay = searchedData.data.osa_settings
        ? searchedData.data.osa_settings
        : osa;
      setOsaToDisplay(data_osaToDisplay);
    }

    setSearching(false);
  };

  const onSubmit = () => { };

  const handleTableChange = async (pagination: any) => {
    setSearching(true);
    setState({
      ...state,
      data: [],
      pagination: pagination,
    });
    const data = await kpiOsaService.getAll(pagination.current);
    setOsaToDisplay(data.data.osa_settings);
    setSearching(false);
  };

  const handleTableSearchChange = async (pagination: any) => {
    const { searchWord } = form.getFieldsValue();
    setSearching(true);
    setState({
      ...state,
      data: [],
      pagination_search: pagination,
    });
    const searchData = [
      {
        key: "manufacturer_name",
        value: encodeURIComponent(searchWord),
        page: pagination.current,
        collection: "osa_settings",
      },
    ];

    const data = await search(searchData, kpiOsaService, "manufacturer_name");
    setOsaToDisplay(data.data);
    setSearching(false);
  };

  useEffect(() => {
    setOsaToDisplay(osa.osa_settings);
    setState({
      ...state,
      pagination: {
        ...state.pagination,
        total: osa.total,
      },
    });
  }, [osa]);

  const loading = searching || loadingOsa;
  return (
    <Layout style={{ padding: 20 }}>
      <Header
        style={{
          textAlign: "left",
          backgroundColor: "#F0F2F5",
          padding: 0,
          borderRadius: 15,
        }}
      >
        <Row>
          <Col span={12}>
            <h3 style={{ fontWeight: "bold", paddingLeft: 0 }}>OSA Settings</h3>
          </Col>
          <Col span={12} style={{ textAlign: "right", paddingRight: 0 }}>
            <Button
              onClick={() => {
                setVisible(true);
                setState({
                  ...state,
                  isCreate: true,
                });
                setSelected(structureOSA(kpi_osa_default));
              }}
              type="primary"
              shape="round"
              icon={<PlusCircleFilled />}
              style={{ width: 150 }}
            >
              Add New
            </Button>
          </Col>
        </Row>
      </Header>
      <Content>
        <Row
          style={{
            textAlign: "left",
            backgroundColor: "white",
            padding: 20,
            borderRadius: 10,
            marginTop: 0,
          }}
        >
          <Col span={24}>
            <Row>
              <Col span={24} style={{ fontWeight: "bold" }}>
                What are you looking for?
              </Col>
            </Row>
            <Row style={{ marginTop: 20 }}>
              <Form
                form={form}
                initialValues={{ searchWord: "" }}
                style={{
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  flexWrap: "wrap",
                }}
                onValuesChange={(changedVals) => {
                  if (changedVals.searchWord === "") {
                    onClose();
                  }
                }}
              >
                <Col>
                  <Form.Item name="searchWord">
                    <Input
                      style={{ width: 300, borderRadius: 10 }}
                      prefix={<SearchOutlined style={{ color: "#ccc" }} />}
                      placeholder={"Search"}
                      suffix={
                        <Tooltip title="Clear Search">
                          <CloseCircleOutlined
                            onClick={() => {
                              setOsaToDisplay(osa.osa_settings);
                              setState({
                                ...state,
                                isCreate: false,
                              });
                              form.setFieldsValue({
                                searchWord: ""
                              })
                            }}
                            style={{
                              color: "rgba(0,0,0,.45)",
                            }}
                          />
                        </Tooltip>
                      }
                    ></Input>
                  </Form.Item>
                </Col>
                <Col style={{ textAlign: "right", paddingRight: 0 }}>
                  <Form.Item>
                    <Button
                      type="primary"
                      shape="round"
                      htmlType="submit"
                      onClick={() => onSearch("manufacturer_name")}
                      style={{ width: 200 }}
                    >
                      Search By Manufacturer
                    </Button>
                  </Form.Item>

                </Col>
              </Form>

            </Row>
          </Col>
        </Row>

        <Row
          style={{
            padding: 20,
            backgroundColor: "white",
            marginTop: 20,
            borderRadius: 15,
          }}
        >
          <Col span={24}>
            {!form.getFieldValue("searchWord") ? (
              <Table
                pagination={state.pagination}
                loading={loading}
                onRow={(record, _) => {
                  return {
                    onClick: () => {
                      setState({
                        ...state,
                        isCreate: false,
                      });
                      setSelected(structureOSA(record));
                      setVisible(true);
                    },
                  };
                }}
                dataSource={osaToDisplay}
                columns={columns}
                onChange={handleTableChange}
              />
            ) : (
              <Table
                pagination={state.pagination_search}
                loading={loading}
                onRow={(record, _) => {
                  return {
                    onClick: () => {
                      setState({
                        ...state,
                        isCreate: false,
                      });
                      setSelected(structureOSA(record));
                      setVisible(true);
                    },
                  };
                }}
                dataSource={osaToDisplay}
                columns={columns}
                onChange={handleTableSearchChange}
              />
            )}
          </Col>
        </Row>
      </Content>
      <OsaForm
        visible={visible}
        form={form}
        values={selected}
        isChanged={false}
        setVisible={setVisible}
        isCreate={state.isCreate}
        onClose={onClose}
      />
    </Layout>
  );
};

export default OsaPage;
